import { render, staticRenderFns } from "./PassageHumanReference.vue?vue&type=template&id=7e94415e&"
import script from "./PassageHumanReference.vue?vue&type=script&lang=js&"
export * from "./PassageHumanReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PassageHumanReference.vue"
export default component.exports